import {
  Create,
  ListButton,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { SimpleBoxLoader } from "@/components/loader";
import { MODULE_NAMES } from "@/constants/modules";
import { BaseDateInput } from "@/inputs/BaseDateInput";
import { ReferenceAutoCompleteArrayInput } from "@/inputs/ReferenceAutoCompleteArrayInput";
import { useCountries } from "@/modules/countries";

import {
  DEFAULT_AMOUNT,
  LIMIT_COUNTRIES_TAGS,
  REWARD_TYPE_OPTIONS,
  ROWS_BY_FILE_OPTIONS,
  amountValidator,
  DEFAULT_DATE_FROM,
  DEFAULT_DATE_TO,
} from "./constants";
import { SaveButtonWithModal } from "./SaveButtonWithModal";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButtonWithModal />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const LeadReportCreate = () => {
  const { data: { countriesList } = {}, isLoading: isLoadingCountries } =
    useCountries();

  const defaultValues = {
    dateFrom: DEFAULT_DATE_FROM,
    dateTo: DEFAULT_DATE_TO,
    amount: DEFAULT_AMOUNT,
    rowsByFile: ROWS_BY_FILE_OPTIONS[0].id,
    rewardType: REWARD_TYPE_OPTIONS[0].id,
    countries: countriesList?.map((country) => country.code),
  };

  if (isLoadingCountries) {
    return <SimpleBoxLoader />;
  }
  return (
    <Create actions={<CreateActions />} redirect="list">
      <SimpleForm toolbar={<CreateToolbar />} defaultValues={defaultValues}>
        <BaseDateInput
          label="Период с"
          source="dateFrom"
          isRequired={true}
          validate={required()}
        />
        <BaseDateInput
          label="Период по"
          source="dateTo"
          isRequired={true}
          validate={required()}
        />
        <TextInput
          label="Сумма"
          source="amount"
          type="number"
          isRequired={true}
          validate={[required(), amountValidator]}
        />
        <SelectInput
          label="Кол-во записей в файл"
          source="rowsByFile"
          validate={required()}
          choices={ROWS_BY_FILE_OPTIONS}
        />
        <SelectInput
          label="Тип"
          source="rewardType"
          validate={required()}
          choices={REWARD_TYPE_OPTIONS}
        />
        <ReferenceAutoCompleteArrayInput
          label="Страны"
          source="countries"
          validate={required()}
          optionValue="code"
          optionText="name"
          module={MODULE_NAMES.COUNTRIES}
          disableCloseOnSelect
          limitTags={LIMIT_COUNTRIES_TAGS}
        />
      </SimpleForm>
    </Create>
  );
};
